import { render, staticRenderFns } from "./ProjectDataFiles.vue?vue&type=template&id=5db01e0e&scoped=true"
import script from "./ProjectDataFiles.vue?vue&type=script&lang=js"
export * from "./ProjectDataFiles.vue?vue&type=script&lang=js"
import style0 from "./ProjectDataFiles.vue?vue&type=style&index=0&id=5db01e0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db01e0e",
  null
  
)

export default component.exports